import React from 'react'
import { take } from 'lib/array/arrayUtils'
import useOfferList from 'hooks/Offers/useOfferList'
import { MAX_CAROUSEL_ITEM_COUNT } from '../../../home/components/OfferCarousels/common/constants'
import FullWidthCarouselWithAnalytics from 'components/WithAnalytics/Carousel/FullWidthCarouselWithAnalytics'
import CarouselCardLoadingSkeleton from './OfferCards/CarouselCardLoadingSkeleton'
import OfferCard from './OfferCards/OfferCard'
import { EmptyObject } from 'lib/object/objectUtils'
import LoaderPlayStateContext from 'contexts/LoaderPlayStateContext'
import { useInView } from 'react-intersection-observer'

interface Props {
  filters?: App.OfferListFilters;
  overrideOfferList?: App.OfferList;
  limit?: number;
  mobileLimit?: number;
}

function OfferListCarousel(props: React.PropsWithChildren<Props>) {
  const {
    filters = EmptyObject,
    overrideOfferList,
    limit = MAX_CAROUSEL_ITEM_COUNT,
    children,
  } = props

  const [filterOfferList] = useOfferList(filters, { disabled: !!overrideOfferList || !filters })
  const offerList = overrideOfferList ?? filterOfferList

  const [inViewRef, carouselInView] = useInView({
    triggerOnce: true,
    rootMargin: '500px',
  })

  return <FullWidthCarouselWithAnalytics
    itemsPerArrow={3}
    snap="start"
    ref={inViewRef}
  >
    {offerList.fetching && <LoaderPlayStateContext.Provider value={carouselInView ? 'running' : 'paused'}>
      <CarouselCardLoadingSkeleton />
      <CarouselCardLoadingSkeleton />
      <CarouselCardLoadingSkeleton />
      <CarouselCardLoadingSkeleton />
    </LoaderPlayStateContext.Provider>}
    {take(offerList.offerIds, limit).map((id: string, idx: number) => (
      <OfferCard
        key={id}
        id={id}
        idx={idx}
        // eager load the first two, this 'preps' the carousel for mobile view
        lazyLoad={idx > 1}
      />
    ))}
    {children}
  </FullWidthCarouselWithAnalytics>
}

export default React.memo(OfferListCarousel)
